export const secondsToInterval = (seconds: number) => {
  const days = Math.floor(seconds / 86400) // 86400 seconds = 1 day
  const hours = Math.floor((seconds % 86400) / 3600) // 3600 seconds = 1 hour
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  const formattedDays = String(days).padStart(2, '0')
  const formattedHours = String(hours).padStart(2, '0')
  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(remainingSeconds).padStart(2, '0')

  return {
    days: formattedDays,
    hours: formattedHours,
    minutes: formattedMinutes,
    seconds: formattedSeconds,
  }
}
